import { Button, Image, Result, Spin } from "antd";
import { ErrorMessage, Field, Form, Formik } from "formik";
import queryString from "query-string";
import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import * as Yup from "yup";
import Logo from "../../assets/images/logo_WasteNoFood_header.gif";
import { API } from "../../config/api";
import { PostAPIRequest } from "../../services/api";
function CancelledPaymentStatus({ history }) {
  const TokenStatus = {
    Validating: "Validating",
    Valid: "Valid",
    Invalid: "Invalid",
    Success: "Success",
    Used: "Used",
  };

  const [token, setToken] = useState(null);
  const [tokenStatus, setTokenStatus] = useState(TokenStatus.Success);

  function getBody() {
    switch (tokenStatus) {
      case TokenStatus.Validating:
        return <Spin size="large" />;
      case TokenStatus.Success:
        return (
          <Result
            status="success"
            title=""
            subTitle="You have cancelled the subscription process!"
          />
        );
    }
  }

  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "90%",
          maxWidth: 500,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Image style={{ marginTop: 40, marginBottom: 30 }} src={Logo} />
        <div
          style={{
            alignSelf: "stretch",
            marginTop: 40,
            marginBottom: 30,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {getBody()}
        </div>
      </div>
    </div>
  );
}

export default CancelledPaymentStatus;
